import { SourceOfFundsFormJson } from '../../../api/AccountService.schemas';
import { SOF_QUESTIONS } from '../SOF.constants';
import { InputType, SOFQuestion } from '../SOF.types';
import { buildRequestData } from './buildRequestData';

export const buildInitialPayload = (
  initialPayload: SourceOfFundsFormJson[] = [],
) => {
  if (initialPayload.length !== SOF_QUESTIONS.length) {
    initialPayload = [];
  }
  return SOF_QUESTIONS.reduce(
    (accumulator, { id, controlId, options }) => ({
      ...accumulator,
      [id]: options
        ? options.reduce(
            (accumulator, { controlId, inputType }) => ({
              ...accumulator,
              [controlId]: {
                answer: '',
                ...extractDefaultParams(inputType),
                ...extractInitialPayload(initialPayload, id, controlId),
              },
            }),
            {},
          )
        : {
            [controlId]: {
              answer: '',
              ...extractInitialPayload(initialPayload, id, controlId),
            },
          },
    }),
    {},
  );
};

const defaultParamsMap: Record<InputType, Record<string, string>> = {
  [InputType.INCOME]: { amount: '', incomeType: '' },
  [InputType.AMOUNT]: { amount: '' },
  [InputType.EMPLOYED]: { jobTitle: '', companyName: '', industry: '' },
  [InputType.SELF_EMPLOYED]: {
    jobTitle: '',
    companyName: '',
    natureOfBusiness: '',
  },
};

export const extractDefaultParams = (inputType?: InputType) =>
  inputType ? defaultParamsMap[inputType] || {} : {};

const extractInitialPayload = (
  initialPayload: ReturnType<typeof buildRequestData>,
  questionId: SOFQuestion['id'],
  controlId: Required<SOFQuestion>['controlId'],
) => {
  const { answers = [] } =
    initialPayload.find((question) => question.questionId === questionId) || {};

  return answers.find((answer) => controlId === answer.controlId) || {};
};
